import React from "react";
import SidenavComponent from "./SidenavComponent";

function Sidenav() {
  return (
    <div className="sideNavigationComonent">
      <SidenavComponent />
      <SidenavComponent />
      <SidenavComponent />
    </div>
  );
}

export default Sidenav;
